let audioContext: AudioContext | null = null;

export function playChatSound() {
  try {
    audioContext ??= new AudioContext();
    const ctx = audioContext;
    const now = ctx.currentTime;

    const playNote = (freq: number, startTime: number, volume: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      const filter = ctx.createBiquadFilter();

      osc.connect(filter);
      filter.connect(gain);
      gain.connect(ctx.destination);

      osc.type = 'sine';
      osc.frequency.value = freq;

      filter.type = 'lowpass';
      filter.frequency.value = freq * 3;
      filter.Q.value = 0.5;

      gain.gain.setValueAtTime(0, startTime);
      gain.gain.linearRampToValueAtTime(volume, startTime + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.001, startTime + 0.35);

      osc.start(startTime);
      osc.stop(startTime + 0.35);
    };

    playNote(523, now, 0.12);        // C5
    playNote(659, now + 0.11, 0.10); // E5
  } catch {
    // AudioContext unavailable or blocked
  }
}
